// ──────────────────────────────────────────────────────────────
// 가족 구성 요약 — 단일 진실 공급원(single source of truth)
//
// 화면(App.js)과 회귀 테스트(scripts/test-familyCount.js)가 "같은 함수"를 씁니다.
// → 규칙을 한 곳에서만 관리하므로, 화면과 테스트가 서로 어긋날 수 없음.
//
// 2026-06-16 버그 박제: "부부 + 자녀 2명인데 총 3명" / 가족 현황에 배우자 누락.
//   원인 — 배우자를 '결혼 여부'가 아니라 '배우자 이름·생년월일까지 입력했는지'로 셌음.
//   배우자 상세는 '선택 입력'이라 안 넣으면 통째로 빠졌음.
//   수정 — 결혼 상태면(사별·조손·미혼 한부모 제외) 상세 입력과 무관하게 배우자 1명 포함.
// ──────────────────────────────────────────────────────────────

// 현재 함께 사는 배우자(생존 파트너)가 있는가?
// - 결혼 상태(u.married)여야 하고,
// - 한부모 유형(사별/조손/미혼)이면 배우자 없음.
function hasSpouse(u) {
  if (!u || !u.married) return false;
  const sp = u.isSingleParent;
  return sp !== "widowed" && sp !== "grandparent" && sp !== "unwed";
}

// 자녀 수
function childCount(u) {
  return u && Array.isArray(u.children) ? u.children.length : 0;
}

// 가족 요약: 총 인원수 + 라벨('부부 · 자녀 2명' 등)
// 본인(1) + 배우자(있으면 1) + 자녀 수
function familySummary(u) {
  const spouse = hasSpouse(u);
  const kids = childCount(u);
  const memberCnt = 1 + (spouse ? 1 : 0) + kids;
  const parts = [];
  parts.push(spouse ? "부부" : "1인");
  if (kids > 0) parts.push("자녀 " + kids + "명");
  return { hasSpouse: spouse, childCount: kids, memberCnt, label: parts.join(" · ") };
}

module.exports = { hasSpouse, childCount, familySummary };
